import styled from 'styled-components';

export const Line = styled.div`
width: 100%;
box-sizing: border-box;
border-bottom: 1px solid #E9EDF5;
margin: 20px 0;
`;